export default async function urlToBlob(fileUrl) {
    const response = await fetch(fileUrl);
    const blob = await response.blob();
    return blob;
}
